import Buttons from '../../elements/modal/recordingDeleteModalButtons';
import Container from '../../atoms/container/modalContainer';
import ChannelDown from '../../elements/images/channelDown';
import ChannelUp from '../../elements/images/channelUp';
import EpgEvent from '@shared/classes/epgEvent';
import Pages from '@pages';
import RecordingModal from '../../elements/modal/recordingModal';
import useKeyboard from '../../../../shared/components/utils/hooks/useKeyboard';
import { useAppDispatch, useAppSelector } from '../../../../shared/store/hooks';
import { store } from '@shared/store/store';
import { routerSelector } from '@shared/store/slices/router.slice';
import {
  channelDown,
  channelUp,
} from '../../../../shared/store/thunks/channels.thunk';
import {
  clearModal,
  modalSelector,
} from '../../../../shared/store/slices/modal.slice';

export default function RecordingDeleteModal() {
  const dispatch = useAppDispatch();
  const { params } = useAppSelector(modalSelector);
  const {
    route: { Page },
  } = useAppSelector(routerSelector);

  useKeyboard({
    canBeFocused: false,
    stopPropagation: true,
    keyDownHandler: (key) => {
      const { router } = store.getState();
      switch (key) {
        case 'BACK':
          dispatch(clearModal());
          break;
        case 'CHANNEL_DOWN':
          if (router.route.Page === Pages.ZAPPER) {
            dispatch(clearModal());
            dispatch(channelDown());
          }
          break;
        case 'CHANNEL_UP':
          if (router.route.Page === Pages.ZAPPER) {
            dispatch(clearModal());
            dispatch(channelUp());
          }
          break;
      }
    },
  });

  return (
    <Container>
      {Page === Pages.ZAPPER && <ChannelUp />}
      <RecordingModal asset={(params as { asset: EpgEvent })?.asset} />
      <Buttons asset={(params as { asset: EpgEvent })?.asset} />
      {Page === Pages.ZAPPER && <ChannelDown />}
    </Container>
  );
}
